import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeCard from '../shared/HomeCard';
import { familyPersonas } from '../config/familyPersonas';

export default function FamilyPersonasFramework() {
  return (
    <div className="page">
      <Link to="/family-dashboard" className="back-link">
        <ArrowBackIcon fontSize="small" /> Back to Family Dashboard
      </Link>
      <div className="page-header">
        <h1 className="page-title">Family Personas</h1>
        <p className="page-subtitle">Persona profiles built from family and household characteristics.</p>
      </div>

      <div className="card-grid">
        {familyPersonas.map((persona) => (
          <HomeCard
            key={persona.id}
            to={`/family-dashboard/personas/${persona.id}`}
            title={persona.title}
            description={persona.tagline}
            icon={persona.icon}
            accent={persona.accent}
          />
        ))}
      </div>
    </div>
  );
}
